import { createFileRoute } from '@tanstack/react-router'
import { PaymentsLogPage } from '@/features/finance/payments-log/pages/payments-log-page'

export const Route = createFileRoute('/_authenticated/customer/finance/payments')({
  component: () => <PaymentsLogPage role='customer' />,
})
